document.addEventListener('DOMContentLoaded', function() {
  const emailInput = document.querySelector('input[type="email"][name="contact[email]"]');
  const fieldWrapper = document.querySelector('.animated-newsletter-form__field-wrapper');

  if (emailInput && fieldWrapper) {
    emailInput.addEventListener('input', function() {
      if (this.value.includes('@')) {
        fieldWrapper.classList.add('is-visible');
      }
    });
  }
});